<template>
  <div class="login">
    <h2>设置密码</h2>
    <div class="inputs">
      <input v-model="pwd" :class="{ 'j-pwd': true, 'error-input': errorInputClass === 'j-pwd' }" @input="toNormalInput('j-pwd')" :type="passwordType" placeholder="密码" maxlength="32" @focus="passwordType = 'password'"/>
      <input v-model="confirmPwd" :class="{ 'j-pwd-confirm': true, 'error-input': errorInputClass === 'j-pwd-confirm' }" :type="passwordType" placeholder="确认密码" maxlength="32" @focus="passwordType = 'password'"/>
      <div class="error">{{ error }}</div>
    </div>
    <div class="buttons">
      <button @click="setPwd" :class="{ disabled: isWorking }">完成设置</button>
    </div>
  </div>
</template>

<script>
import { checkSetPwd } from '@/api/digestCheck'
import { setPwd } from '@/api/userPassword'
import Constants from '@/assets/constants/Constants'
export default {
  name: 'SetPwdPage',
  layout: 'LoginLayout',
  data () {
    return {
      profile: {},
      passwordType: 'text',
      isWorking: false, // 设置中
      pwd: '',
      confirmPwd: '',
      error: '',
      errorInputClass: null
    }
  },
  methods: {
    // 转成正常输入框
    toNormalInput (inputClassName) {
      if (inputClassName === this.errorInputClass) {
        this.errorInputClass = null
        this.error = ''
      }
    },
    // 设置密码
    setPwd () {
      if (this.isWorking) return
      const pwd = this.pwd.trim()
      // 校验
      if (pwd.length === 0) {
        document.getElementsByClassName('j-pwd')[0].focus()
        this.errorInputClass = 'j-pwd'
        this.error = '请输入密码'
        return
      }
      if (pwd.length < 6) {
        document.getElementsByClassName('j-pwd')[0].focus()
        this.errorInputClass = 'j-pwd'
        this.error = '密码不能少于6位'
        return
      }
      if (pwd.indexOf(' ') > -1) {
        document.getElementsByClassName('j-pwd')[0].focus()
        this.errorInputClass = 'j-pwd'
        this.error = '密码不能包含空格'
        return
      }

      if (this.confirmPwd.trim().length === 0) {
        document.getElementsByClassName('j-pwd-confirm')[0].focus()
        this.errorInputClass = 'j-pwd-confirm'
        this.error = '请输入确认密码'
        return
      }
      if (this.confirmPwd !== this.pwd) {
        document.getElementsByClassName('j-pwd-confirm')[0].focus()
        this.errorInputClass = 'j-pwd-confirm'
        this.error = '两次密码输入不一致'
        return
      }

      // 发送请求
      this.error = ''
      this.isWorking = true
      setPwd(this.profile, pwd)
        .then(data => {
          this.isWorking = false
          // 如果包含重定向地址
          if (data != null && data.redirectUri != null) {
            const token = data.token
            window.location.href = `${data.redirectUri}?access_token=${token.token}&timestamp=${token.timestamp}&digest=${token.digest}&payload=${encodeURIComponent(this.$route.query.payload)}`
            return
          }
          this.$router.push('/pwd/reset/success')
        })
        .catch(({ message }) => {
          this.isWorking = false
          this.error = message
        })
    }
  },
  async created () {
    const noprofile = () => {
      this.$router.push('/500?code=INVALID_URI&error=无效的链接或链接已超时')
    }
    if (
      this.$route.query.secure == null ||
      this.$route.query.timestamp == null ||
      this.$route.query.digest == null
    ) {
      noprofile()
      return
    }
    await checkSetPwd(this.$route.query.secure, this.$route.query.timestamp, this.$route.query.digest)
      .then(() => {
        // 填充授权信息
        this.profile = {
          secure: this.$route.query.secure,
          timestamp: this.$route.query.timestamp,
          digest: this.$route.query.digest
        }
      })
      .catch(({ code, message }) => {
        if (code === Constants.Status.INVALID_URI.code) {
          noprofile()
          return
        }
        this.$router.push(`/500?code=${code}&error=${message}`)
      })
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/style/login/login';
</style>
